import { Col, Input, Row, Select, Tooltip, message, Button, Radio } from "antd";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { CSVLink } from "react-csv";
import { FileExcelFilled } from "@ant-design/icons";
import { useSearchParams } from "react-router-dom";
const { Option } = Select;

const AbhaLinkedFilter = ({
  searchHide,
  filter,
  setFilter,
  setPage,
  headers,
  FilteredData,
  setFilteredData,
  filename = (val) => {},
  enableScanFilter = false,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [values, setValues] = useState({
    searchString: "",
    fromDate: "",
    toDate: "",
    page: 1,
    isScanned: "",
  });
  useEffect(() => {
    if ([...searchParams.entries()].length === 0) return;
    const searchStringFromParams = searchParams.get("searchString") || "";
    const fromDateFromParams = searchParams.get("fromDate") || "";
    const toDateFromParams = searchParams.get("toDate") || "";
    const pageFromParams = parseInt(searchParams.get("page"), 10) || 1;
    const isScannedFromParams = searchParams.get("isScanned") || "";
    setValues((prevValues) => ({
      ...prevValues,
      searchString: searchStringFromParams,
      fromDate: fromDateFromParams,
      toDate: toDateFromParams,
      page: pageFromParams,
      isScanned: isScannedFromParams,
    }));

    setFilter({
      searchString: searchStringFromParams,
      fromDate: fromDateFromParams,
      toDate: toDateFromParams,
      page: pageFromParams,
      isScanned: isScannedFromParams,
    });
  }, [searchParams]);

  const handleChange = (name, value) => {
    setValues({ ...values, [name]: value });
  };
  const handleFilter = () => {
    const params = new URLSearchParams();
    Object.keys(values).map((searchParameter) => {
      if (values[searchParameter]) {
        params.set(searchParameter, values[searchParameter]);
      }
    });
    setSearchParams(params);
    setFilter({ ...filter, ...values });

    setPage(1);
  };
  const handleFilterReset = () => {
    // Reset filter state
    setFilter({});
    setValues({
      searchString: "",
      fromDate: "",
      toDate: "",
      page: 1,
      isScanned: "",
    });
    setPage(1);

    // Clear URL search parameters
    setSearchParams(new URLSearchParams());
  };

  return (
    <div className="table_filter">
      <Row gutter={[24, 20]} className="ml-10">
        <Col md={5} sm={12} xs={24}>
          <strong>
            {" "}
            <p className="mb-2">From Date</p>
          </strong>
          <Input
            type="date"
            id="fromdate"
            autoComplete="new-off"
            className="form-control"
            onChange={(e) => handleChange("fromDate", e.target.value)}
            max={moment().format("YYYY-MM-DD")}
            placeholder="From Date"
            value={values?.fromDate}
          />
        </Col>

        <Col md={5} sm={12} xs={24}>
          <strong>
            <p className="mb-2">To Date</p>
          </strong>
          <Input
            type="date"
            id="todate"
            autoComplete="todate"
            className="form-control"
            onChange={(e) => handleChange("toDate", e.target.value)}
            min={values?.fromDate}
            placeholder="To Date"
            value={values?.toDate}
          />
        </Col>
        {!searchHide && (
          <Col md={6} sm={4} xs={24}>
            <strong>
              {" "}
              <p className="mb-2">Search</p>
            </strong>
            <Input
              type="text"
              autoComplete="new-off"
              className="form-control"
              onChange={(e) => handleChange("searchString", e.target.value)}
              placeholder="Search"
              value={values?.searchString}
            />
          </Col>
        )}
        {enableScanFilter && (
          <Col md={3} sm={12} xs={24}>
            <strong>
              <p>Scanned Filter</p>
            </strong>
            <Radio.Group
              onChange={(e) => handleChange("isScanned", e.target.value)}
              value={values.isScanned}
            >
              <Radio value="1">Scanned</Radio>
              <Radio value="">All</Radio>
            </Radio.Group>
          </Col>
        )}
        <Col md={3} sm={12} xs={24}>
          <div className="flex gap10 mt-20">
            <button className="filter-button" onClick={() => handleFilter()}>
              Filter
            </button>
            <button
              className="clear-button"
              onClick={() => handleFilterReset()}
            >
              Reset
            </button>
            <CSVLink
              filename={filename + ".csv"}
              data={FilteredData}
              headers={headers}
              className="ex-export2 mt-0"
              onClick={() => {
                message.success("The file is downloading");
              }}
            >
              <Tooltip
                placement="top"
                title={"A user can download only single page data once."}
                arrow={false}
              >
                <Button className="export-csv"> Export to CSV </Button>
              </Tooltip>
            </CSVLink>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default AbhaLinkedFilter;
